import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { SharedButtonDropdownModule } from '../../../shared-ui-refresh/dropdown/dropdown.module';
import { TermsAndConditionsService } from './services/terms-and-conditions.service';
import { TermsAndConditionsComponent } from './terms-and-conditions.component';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  declarations: [TermsAndConditionsComponent],
  imports: [
    CommonModule,
    NgbModule,
    DropDownsModule,
    TranslateModule.forChild({
     loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix: '.json?v=' + Date.now()}),
       compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      }
    }),
    SharedButtonDropdownModule
  ],
  providers: [TermsAndConditionsService],
  exports: [TermsAndConditionsComponent]
})
export class TermsAndConditionsModule { }
